// Podtitulek v hlavičce okna — prezentační komponenta (styl `pwm-subtitle`). Znovupoužitelná i mimo
// hlavičku (v obsahu stránky), aby detaily měly jednotný vzhled podtitulku.

import type { ReactNode } from 'react';

export function WindowSubtitle({ children }: { children: ReactNode }) {
  return <span className="pwm-subtitle">{children}</span>;
}
